import { UpdateRegistrationProps } from '@commenda/types/src/registration/types';
import { fetcher } from '@commenda/utils';

export async function updateRegistration(
  businessEntityId: number,
  registrationId: string,
  body: UpdateRegistrationProps
) {
  const response = await fetcher(
    `business-entities/${businessEntityId}/registrations/${registrationId}`,
    {
      method: 'PATCH',
      body,
    }
  );

  return response;
}
